import { Component, OnInit, inject } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { takeUntil } from "rxjs/operators";

import { PageNames } from "src/app/configs/page-names.enum";
import { QueryStringTypesEnum } from "src/app/configs/query-string-types";
import {
  GetAllNumbersListDto,
  TransferPrivateNumberCommand,
} from "src/app/core/api/models";
import { PrivateNumbersService } from "src/app/core/api/services";
import { NumberTypeDisplay } from "src/app/core/enums/display/number-type.display";
import { FormPageConfig } from "src/app/core/models/form-page-config.model";
import { ApiNotificationService } from "src/app/core/services/api-notification.service";
import { DialogService } from "src/app/core/services/dialog.service";
import { DynamicTableService } from "src/app/core/services/dynamic-table.service";
import { GetEnumValuesDto } from "../../../core/api/models/get-enum-values-dto";
import { OrganizationsService } from "../../../core/api/services/organizations.service";
import { BaseIndexPageComponent } from "../../shared/base/components/base-index-page.component";
import { BaseIndexModule } from "../../shared/base/modules/base-index.module";
import { TransferPrivateNumberFormComponent } from "./transfer-private-numbers-form/transfer-private-numbers-form.component";

@Component({
  selector: "app-transfer-private-numbers",
  templateUrl: "./transfer-private-numbers.component.html",
  imports: [BaseIndexModule, TransferPrivateNumberFormComponent],
})
export class TransferPrivateNumbersComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties
  pageName = PageNames.transferPrivateNumbers;
  protected currentService = inject(PrivateNumbersService);

  /* Binding service endpoints */
  paginationApiMethodName: string =
    this.currentService.privateNumbersGetAllNumbersForOrganizationWithPagination
      .name;
  auditApiMethodName: string =
    this.currentService.privateNumbersGetPrivateNumberTransferHistoryAudits
      .name;

  modelWithPagination$: Observable<any>;
  items$: Observable<Array<GetAllNumbersListDto>>;
  formPageConfig: FormPageConfig<TransferPrivateNumberCommand> = {};

  public NumberTypeDisplay: typeof NumberTypeDisplay = NumberTypeDisplay;
  privateNumber: any;
  preOwner: any;
  NumberTypeEnumValues: GetEnumValuesDto[] = [];
  SmsCpEnumValues: GetEnumValuesDto[] = [];

  //#region Properties

  constructor(
    public dialogService: DialogService,
    public apiNotificationService: ApiNotificationService,
    public dynamicTableService: DynamicTableService,
    public organizationsService: OrganizationsService // protected userSession: userSession, // protected enumService: EnumsService, // protected elementRef: ElementRef, // protected loggerService: LoggerService
  ) {
    super();
  }
  ngOnInit() {
    super.ngOnInit();
    this.pageConfig.showAddBtn = false;
  }

  getEnumsValues() {
    this.getEnumValuesApi("NumberType")
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.NumberTypeEnumValues = values));
    this.getEnumValuesApi("SmsCp")
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.SmsCpEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: this.localizer.number,
        name: "number",
        hasSearch: true,
        dir: "ltr",
      },
      {
        title: `${this.tableVocabs}numberType`,
        name: "numberType",
        hasSearch: true,
        type: "enum",
        enumName: "NumberType",
      },
      {
        title: "common.smsCp",
        name: "smsCp",
        hasSearch: true,
        type: "enum",
        enumName: "SmsCp",
      },
      {
        title: this.localizer.expireDate,
        name: "expireDate",
        type: "date",
        hasSearch: true,
      },
      {
        title: "common.PrivateNumberCreated",
        name: "PrivateNumber.Created",
        hasSearch: false,
        noSorting: true,
        type: "dateTime",
      },
      {
        title: `${this.tableVocabs}TransferDateTime`,
        name: "PrivateNumber.Created",
        hasSearch: false,
        noSorting: true,
        type: "dateTime",
      },
    ];
  }

  // وارد میشود چک میکنیم که کدام جدول باید نمایش داده شود url زمانی که کاربر با
  setPageAfterEnterUrl() {
    super.setPageAfterEnterUrl();
    let params = this.routingState.parseQueryString();
    for (const [key, value] of Object.entries(params)) {
      if (key == QueryStringTypesEnum.TransferPrivateNumber_key)
        this.transferPrivateNumber(
          value.toString().split("_")[0],
          value.toString().split("_")[1],
          value.toString().split("_")[2],
          value.toString().split("_")[3],
          false
        );
    }
  }
  //#region Api

  setDefaultTableSort() {
    this.sortObject.push({ columnName: "expireDate", sort: 1 });
  }

  //Get ById
  transferPrivateNumberGetApi(id, number, ownerName, ownerId): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.currentService
      .privateNumbersTransferPrivateNumberGet()
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        if (res) {
          this.formPageConfig.isEditMode = true;
          this.formPageConfig.editData = {};
          this.formPageConfig.editData.privateNumberId = id;
          this.formPageConfig.editData.preOwnerId = ownerId;
          this.privateNumber = number;
          this.preOwner = ownerName;
          this.pageConfig.isVisibleForm = true;
        }
      });
  }

  //#endregion

  transferPrivateNumber(id, number, ownerName, ownerId, setUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    if (setUrl) {
      this.location.go(
        window.location.pathname +
          "?" +
          QueryStringTypesEnum.TransferPrivateNumber_key +
          "=" +
          id +
          "_" +
          number +
          "_" +
          ownerName +
          "_" +
          ownerId
      );
    }
    this.transferPrivateNumberGetApi(id, number, ownerName, ownerId);
  }

  closeTransferPage() {
    this.location.go(window.location.pathname);
    this.showParent = true;
    this.getParentQueryString();
    this.ngOnInit();
    this.pageConfig.isVisibleForm = false;
  }
}
